import { useI18n } from '../i18n';
import styles from './Pour.module.css';

/**
 * Pouring mode — the argument the whole product rests on.
 *
 * The demo panel is ink filling the frame, which is where the "pour white"
 * value from the spec lives: the amount and the filled gauge. The gauge is
 * fourteen segments with six filled, exactly as the app draws it.
 */
const GAUGE_SEGMENTS = 14;
const GAUGE_FILLED = 6;

export function Pour() {
  const { t } = useI18n();
  const d = t.pour.demo;

  return (
    <section className={styles.section} id="pour">
      <div className={styles.copy}>
        <p className={`caps ${styles.kicker}`}>{t.pour.kicker}</p>
        <h2 className={styles.headline}>
          {t.pour.headlineA}
          <br />
          {t.pour.headlineB}
        </h2>
        <p className={styles.body}>{t.pour.body}</p>
        <ul className={styles.claims}>
          {t.pour.claims.map((claim) => (
            <li key={claim} className={styles.claim}>
              {claim}
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.demo} aria-hidden="true">
        <p className={styles.demoStep}>{d.step}</p>

        <p className={styles.amount}>{d.amount}</p>
        <p className={styles.of}>{d.of}</p>

        <div className={styles.gauge}>
          {Array.from({ length: GAUGE_SEGMENTS }, (_, i) => (
            <span key={i} className={`${styles.seg} ${i < GAUGE_FILLED ? styles.segOn : ''}`} />
          ))}
        </div>

        <div className={styles.readout}>
          <span>{d.inGlass}</span>
          <span>{d.whenDone}</span>
        </div>

        <div className={styles.instruction}>
          <h3 className={styles.demoTitle}>{d.title}</h3>
          <p className={styles.demoBody}>{d.body}</p>
        </div>

        <div className={styles.next}>
          <span className={styles.nextLabel}>{d.nextLabel}</span>
          <span className={styles.nextTitle}>{d.nextTitle}</span>
        </div>

        <p className={styles.done}>{d.done}</p>
      </div>
    </section>
  );
}
